import React from 'react';
import UnitField from './UnitField';

const UnitForm = () => {
  return (
    <form className="ui large form error" id="unit-form">
      <UnitField />
    </form>
  );
};

export default UnitForm;
